import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";
import OpenIntercomLink from "./open-intercom-link";

export default pure(function ContactSupport({ extraButtons, isError, message, subtle }) {
  return (
    <div className={classes({
      "notification": true,
      "notification--subtle": subtle,
      "notification--caution": !isError,
      "notification--error": isError,
      "notification--is-visible": true
    })}>
      <div className="notification_content">
        <div className="notification_icon">
          <i className="dw-warning6" />
        </div>

        <div className="notification_body">
          <h2 className="notification_title">
            {message}
          </h2>

          <p>
            Please contact us if you have any questions.
          </p>

          <p>
            <OpenIntercomLink className="btn btn--transparent">
              Contact Support
            </OpenIntercomLink>

            <span>
              {" "}
              or

              {" "}
            </span>

            <a className="btn btn--transparent" href="tel:502-650-9390">
              Call 502-650-9390
            </a>

            {extraButtons}
          </p>
        </div>
      </div>
    </div>
  );
});
